<template>
  <div style="display: flex; flex-direction: column;height: 100vh;" :style="{background:type==='0' ? '#F0F8FD' : '#F1F8F2'}">
    <div class="product-title" >
      <div class="title-content">
          <div>{{product['prodCompany']}}</div>
          <div style="height: 2px;width: 30px;margin-top:3px;background: #2c3e50;"></div>
          <div style="font-size: 20px;font-weight: 650;margin-top: 10px;">{{product['prodName']}}</div>
          <div style="font-weight: 400;margin-top: 5px;font-size: 12px;">益宝平台仅提供产品展示和推广支持服务，保险产品由保险公司负责提供， 由保险经纪公司负责销售。</div>
      </div>

    </div>

    <!-- 商品分销 -->
    <div class="goods-distribution" v-if="prodDistribution['is_dealer']==1">
      <div class="txt1">贡献值比例：{{prodDistribution['first_money']}}%</div>
      <div class="txt2">预计可得贡献值：{{prodDistribution['commission']}}</div>
      <div class="btn">
        <div @click="immediateShare">分享产品链接</div>
        <div @click="sharePoster" style="margin-left: 10px;">分享产品海报</div>
      </div>
    </div>




    <!-- https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20230119/7120f650e6ea41e3e02d239d6f0e27c2.png -->
    <van-image
      width="98%"
      style="margin-right: 15px;margin-left: 5px;margin-top: 20px;"
      fit="cover"
      :src="product['h5DetailIntroduceImg']"
  />


    <div style="height: 120px;padding-bottom: 50px;">
      <div class="share" @click.stop="">
        <div class="ransmission">保障传递</div>
        <div style="color: #333333;font-size: 12px;">点击分享，将这份保障传递给身边有需要的人</div>
        <div style="color: #3894FF;font-size: 14px;font-weight: bold;" @click.stop="immediateShare">立即分享</div>
      </div>
    </div>

    <div class="immediate-insurance" @click="immediateInsurance(product)">立即投保</div>

    <!--@confirm="saveImgShare"-->
    <van-dialog v-model="show" width="95vw"  :before-close="beforeClose" :confirm-button-text="confirmBtnTxt" @confirm="saveImgShare">
      <template #default>
       <div class="dialog-content" id="dialogContent" v-if="!imagePosterUrl">
           <img style="width: 100%;height: 100vh;" :src="prodDistribution.poster" crossOrigin="anonymous"/>
           <div style="position: absolute;bottom: 10px;left: 20px;">
             <vue-qr
                 class="qrCode"
                 ref="qrCode"
                 :text="qrCode.text"
                 :logoSrc="qrCode.logoSrc"
                 :color-dark="qrCode.randomColor"
                 :callback="qrCodeCallback"

             ></vue-qr>
           </div>
       </div>

       <div class="dialog-content" v-else>
         <img style="width: 100%;height: 100vh;" :src="imagePosterUrl"/>
       </div>

      </template>


    </van-dialog>

    <!-- 联系我们二维码 -->
    <van-dialog v-model="showCustomer" width="95vw"  :before-close="beforeClose" confirm-button-text="关闭" @confirm="showCustomer=false"
    >
      <template #default>

        <div class="dialog-content" >
          <img style="width: 100%;height: auto;object-fit: cover" :src="customerQrcodeImg"/>
        </div>

      </template>


    </van-dialog>

    <!-- 联系客服 -->
<!--    <div-->
<!--        ref="draggableDiv"-->
<!--        class="draggable-container"-->
<!--        :style="{ top: top + 'px', left: left + 'px' }"-->
<!--        @touchstart="onDragStart"-->
<!--        @touchmove="onDragMove"-->
<!--        @touchend="onDragEnd"-->
<!--        @mousedown="onDragStart"-->
<!--        @mousemove="onDragMove"-->
<!--        @mouseup="onDragEnd"-->
<!--    >-->
      <van-image  radius="50%" :src="customerImg" @click="showCustomer = true" width="100px"
                  height="auto" class="link-customer" />
<!--    </div>-->

  </div>
</template>

<script>

import Vue from 'vue';
import {Dialog, Image, Stepper, Tab, Tabs, Toast} from 'vant';
import {wxChatShare} from '@/utils/wxShare'
import Cookies from "js-cookie";
import VueQr from 'vue-qr'
import html2canvas from "html2canvas";


Vue.use(Image).use(Tab).use(Tabs).use(Stepper).use(Dialog);
export default {
  name: "CustProductDetail",
  components: {
    VueQr,html2canvas
  },
  data() {
    return {
      type: Cookies.get('type'),
      user: this.$store.state.user.user,
      active: 0,
      id: this.$route.query.id || localStorage.getItem("detailProductId") || '',
      product: {},
      selectedPrice: {},
      numberValue: 1,
      show: false,
      confirmBtnTxt:'生成分享图片',
      imagePosterUrl: '',
      longPressTimer: null, // 用于存储长按定时器的引用
      customerImg: Cookies.get('type') === '0' ? 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/customer-link00-1.png' : 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/customer-link01-1.png',
      showCustomer: false,
      customerQrcodeImg: Cookies.get('type') === '0' ? 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod-detail00-1.png' : 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod-detail01-1.png',
      prodDistribution:{
        first_money:0,//分销佣金比例
        poster:'',//海报链接
        price: 0, //商品最低价
        commission: 0, //分销佣金最低价
        is_dealer:0,//是否展示佣金信息
      },
      qrCode:{
        text:'',
        logoSrc: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20240907/063098a178dbeb62a9eecbc59fdb0722.png", // 二维码中间的图片
        randomColor: 'black', // 二维码颜色

      },

      isDragging: false,      // 是否正在拖动
      hasMoved: false,      // 新增：是否真的移动了
      moveThreshold: 5,      // 新增：移动超过5px才认为是拖拽
      startPos: { x: 0, y: 0 }, // 鼠标/触摸起点坐标
      startTop: 0,             // 拖动开始时元素的位置
      startLeft: 0,
      top: 0,                  // 元素当前top值
      left: 0,
      containerWidth: 0,       // 用于边界计算
      containerHeight: 0,
      viewportWidth: 0,
      viewportHeight: 0,

    }
  },
  mounted() {
    // 初始化位置（例如：右下角）
    this.viewportWidth = window.innerWidth;
    this.viewportHeight = window.innerHeight;
    // 假设容器宽高为80px
    this.top = this.viewportHeight - 80 - 20; // 距离底部20px
    this.left = this.viewportWidth - 80 - 20; // 距离右边20px

    // 监听窗口大小变化，防止拖出边界
    window.addEventListener('resize', this.updateViewport);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport);
  },
  created() {
    //第二次装发的时候为空
    if(this.id){
      localStorage.setItem("detailProductId",this.id)
    }
     this.$axios.get('product/info-nologin', {params: {
                  productId: this.id,    
                  shareId: Cookies.get('shareId')
         }}).then((res) => {
         this.product = res.data;
         if (this.product.prodPrice && this.product.prodPrice.length > 0) {
             this.selectedPrice = res.data.prodPrice[0]
         }
         this.settingShare(false)
     })
    //初始化分销
    this.initDistribution()

    console.log(this.$route.fullPath,">>>")

    let url = process.env.VUE_APP_SHARE_URL + this.$route.fullPath + '&shareId=' + this.$store.state.user.user.userId
    this.qrCode.text = url

  },
  methods: {
    settingShare(isSave) {
      let name = this.user.userName || this.user.loginName || ''
      let title = ` 向您推荐了 ${this.product['prodName']}`
      let param = {
        url: window.location.href.split('#')[0], // 当前页面url
        title: name + title, // 分享数据配置 主标题
        desc: this.product.prodDescribe, // 分享数据配置 副标题
        link: process.env.VUE_APP_SHARE_URL + '/custProductDetail?shareId=' + this.user.userId + '&type=' + this.type + '&id=' + this.product.productId, // 分享数据配置
        imgUrl: this.product.image || this.product.prodImage || 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20191014/fc038003a2ec7ae47b3bd2480f18ead5.png', // 分享数据配置 －－ 全路径
        type: "link", // 分享类型,music、video或link，不填默认为link
        dataUrl: " ", // 如果type是music或video，则要提供数据链接，默认为空
        productId: this.product.productId,
        isProduct: true,
        isSave:isSave
       }
      wxChatShare(param);
    },
    immediateShare(){
   /*   this.$axios.post('product/save-detail-opinfo',  {productId: this.id}).then((res) => {
        let data = res.data;
      this.settingShare()
      })*/
      this.settingShare(true)
      this.$parent.share()

    },
    getUrlPara() {
      let url = document.location.toString();
      localStorage.setItem("location_host",window.location.host)
      let arrUrl = url.split("?");
      let para = arrUrl[1];
      localStorage.setItem("link_params",para)

       return para;

    },
    async immediateInsurance(item){
      let res =  await this.$axios.post(`product/save-detail-opinfo?time=${Date.parse(new Date())}`, {
        productId: this.id,
        type: 2
      })
      if (res && res.code === 200) {
        this.fun(item);
      }else{
        this.$toast({message: res.msg, duration: 700});
      }


    },
    fun(item){
      //判断是否绑定手机号，没有则提示用户绑定
      let user = localStorage.getItem("user")
      this.getUrlPara()
      if (!user || !JSON.parse(user)['userPhone']) {
        this.$router.push({path: '/login', query: {redirectUrl: location.href}})
        return;
      }
      localStorage.removeItem("location_host")
      localStorage.removeItem("link_params")


      //产品为特殊产品，需要直接跳转到外部链接
      if(item['prodShape'] ==='1' && item['jumpConnection']){
        window.location.href = item['jumpConnection']
        return;
      }
      if (item['prodShape'] === '1' || item['prodType'] === '1') {
        this.$router.push({path: '/productDetail', query: {id: item.productId}})
      } else {
        this.$axios.get("/jump/prodUrl", {
          params: {
            productId: item.productId,
            shareId: Cookies.get('shareId')
          }
        }).then(res => {
          // window.location.href = res.data
          window.open(res.data, '_parent')
        });
      }

    },
    buy() {
      if (this.product.prodType === '1') {//体检
        if (this.active != 2) {
          this.active = 2;
          window.scrollTo(0, document.documentElement.clientHeight);
          return;
        }
        if (this.selectedPrice.priceId) {
          this.$router.push({
            path: '/buy',
            query: {
              number: this.numberValue,
              productId: this.id,
              price: this.selectedPrice.price,
              priceId: this.selectedPrice.priceId
            }
          })
        } else {
          this.$toast({message: '请选择要投保的产品', duration: 700});
        }
      } else {
        window.location.href = this.product.jumpConnection
      }
    },
    selectedPriceClick(item) {
      this.selectedPrice = item
    },
    /**
     * 分销
     */
    initDistribution(){
      this.$axios.get(`mini-program/prod-distribution`,{params: {productId: this.id}}).then(res => {
          //分销信息不为空，则展示分销信息
          if(res.data){
            this.prodDistribution= res.data
          }
      }).catch(err => {
          this.$toast({message: '获取分销信息失败', duration: 700});
      })
    },
    sharePoster(){
     /* let name = this.user.userName || this.user.loginName || ''
      let title = ` 向您推荐了 ${this.product['prodName']}`
      let param = {
        url: window.location.href.split('#')[0], // 当前页面url
        title: this.prodDistribution.poster, // 分享数据配置 主标题[这个才有用]
        // desc: this.prodDistribution.poster, // 分享数据配置 副标题
        link: this.prodDistribution.poster, // 分享数据配置
        imgUrl: this.prodDistribution.poster, // 分享数据配置 －－ 全路径
        type: "link", // 分享类型,music、video或link，不填默认为link
        dataUrl: ' ', // 如果type是music或video，则要提供数据链接，默认为空
        productId: this.product.productId,
        isProduct: true,
        isSave:false
      }
      wxChatShare(param);

      this.$parent.share()*/



      let that = this
      that.show = true

      // this.$router.push({path: '/sharePoster', query: {id: this.id, mainPosterImg: this.prodDistribution.poster}});

    },
    saveImgShare(){
      if(this.imagePosterUrl){
        this.$toast({message: '请长按图片保存分享图片。', duration: 1500});
        return;
      }

      //此提示对安卓保存图片存在兼容问题
 /*     Toast.loading({
        mask: true,
        message: '生成海报中...'
      });*/

      const content = document.getElementById("dialogContent");
      html2canvas(content, {
              useCORS: true,// 使用 CORS 模式加载资源
              allowTaint: false, // 禁止加载被污染的图像
              scale: 2// 设置 scale 提高清晰度
              })
          .then((canvas) => {
            // 将 Canvas 转换为图片 URL
            const imageUrl = canvas.toDataURL("image/png");
            this.imagePosterUrl = imageUrl;
            this.confirmBtnTxt = "长按图片保存海报图片";

         /*   Toast.clear();
            this.$toast({message: '海报已生成，请长按图片保存海报。', duration: 1500});*/


          })
          .catch((error) => {
            console.error("截图失败：", error);
          });
    },
    qrCodeCallback(url){
        // console.log(url,">>>")
    },
    saveImage(dataUrl) {
      //方式1 ： 创建一个临时链接，用于下载图片
    /*  const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "screenshot.png"; // 图片的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);*/

      // 方式2 ：如果要调用微信 JSSDK 保存到相册，需结合微信授权 （微信小程序功能）
      // let param = {
      //   url: window.location.href.split('#')[0], // 当前页面url
      //   imageUrl: dataUrl,
      // }
      // wxChatSaveImg(param)

      //this.$toast({message: '长按已识别，请点击下方链接保存图片或长按图片在新标签页中打开然后保存。', duration: 1500});

    },
    handleTouchStart(event) {
      // 清除之前的定时器（如果有的话）
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
      }

      // 设置定时器，等待一定时间（如500ms）来判断是否为长按
      this.longPressTimer = setTimeout(() => {
        this.saveImage();
      }, 500);

      // 阻止默认行为（可选，根据需要）
      event.preventDefault();
    },

    handleTouchEnd(event) {
      // 清除定时器，防止长按被触发
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
    },

    handleTouchCancel(event) {
      // 清除定时器（如果触摸被取消）
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        done(false)
      } else {
        // 对于其他事件，如 cancel 或 overlay，允许关闭
        done();
      }
    },

    // 更新视口大小并修正位置
    updateViewport() {
      this.viewportWidth = window.innerWidth;
      this.viewportHeight = window.innerHeight;
      this.ensureWithinBounds();
    },

    // 拖拽开始
    onDragStart(e) {
      e.preventDefault(); // 防止拖动时选中文本或默认行为
      this.isDragging = true;
      this.hasMoved = false;  // 重置移动标记

      // 获取当前元素的位置
      const rect = this.$refs.draggableDiv.getBoundingClientRect();
      this.startTop = rect.top;
      this.startLeft = rect.left;
      this.containerWidth = rect.width;
      this.containerHeight = rect.height;

      // 获取鼠标/触摸起点坐标
      const clientX = e.clientX ? e.clientX : (e.touches ? e.touches[0].clientX : 0);
      const clientY = e.clientY ? e.clientY : (e.touches ? e.touches[0].clientY : 0);
      this.startPos = { x: clientX, y: clientY };
    },

    // 拖拽进行中
    onDragMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();

      const clientX = e.clientX ? e.clientX: (e.touches ? e.touches[0].clientX : 0);
      const clientY = e.clientY ? e.clientY: (e.touches ? e.touches[0].clientY : 0);

      // 计算移动距离
      const moveX = Math.abs(clientX - this.startPos.x);
      const moveY = Math.abs(clientY - this.startPos.y);

      // 如果移动距离超过阈值，标记为真的拖拽
      if (moveX > this.moveThreshold || moveY > this.moveThreshold) {
        this.hasMoved = true;
      }

      // 只有真的移动了才更新位置（节省性能）
      if (this.hasMoved) {
        let newLeft = this.startLeft + (clientX - this.startPos.x);
        let newTop = this.startTop + (clientY - this.startPos.y);

        newLeft = Math.max(0, Math.min(newLeft, this.viewportWidth - this.containerWidth));
        newTop = Math.max(0, Math.min(newTop, this.viewportHeight - this.containerHeight));

        this.left = newLeft;
        this.top = newTop;
      }
    },

    // 拖拽结束
    onDragEnd(e) {
      e.preventDefault();
      this.isDragging = false;
    },

    // 确保元素在边界内（用于窗口大小改变后）
    ensureWithinBounds() {
      this.left = Math.max(0, Math.min(this.left, this.viewportWidth - this.containerWidth));
      this.top = Math.max(0, Math.min(this.top, this.viewportHeight - this.containerHeight));
    },

    clickLinkCustomer(){
      // 只有当没有发生拖拽时，才执行点击逻辑
      if (!this.hasMoved) {
        this.showCustomer = true;
      }

    },



  }
}
</script>

<style scoped>
.product-title{
  background-image: url("https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/h5-person.png");
  width: 90%;
  height: 160px;
  background-position: center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  top: -40px;
}
.title-content{
  height: 140px;
  width: 100vw;
  background: #FFFFFF;
  border-radius: 10px;
  position: relative;
  top: 60px;
  padding: 10px 30px;

}
.share{
  width: 97%;
  background: #FFFFFF;
  height: 50px;
  line-height: 50px;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.share .ransmission{
  background: #1987F5;
  border-radius: 15px;
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  color: #FFFFFF;
  padding: 0 10px;
}

.immediate-insurance{
  height: 50px;
  line-height: 50px;
  background: #1987F5;
  color: #FFFFFF;
  text-align: center;
  font-weight: bold;
  font-size: 25px;
  position: fixed;
  bottom: 0px;
  width: 100vw;
}
.draggable-container {
  position: fixed; /* 使用 fixed 相对于视口定位，更常用 */
  /* 或者使用 absolute，需要父级设置 position: relative */
  z-index: 9;
  cursor: move; /* 鼠标样式 */
  user-select: none;
  -webkit-user-drag: none;
  touch-action: none; /* 关键：禁止微信默认的触摸滚动 */
  -webkit-tap-highlight-color: transparent;
  will-change: transform; /* 开启硬件加速，提升流畅度 */


}

.goods-distribution{
  margin: 20px 20px 0;
  background: #FFFFFF;
  box-shadow: 2px 2px 6px 2px rgba(219, 219, 219, 0.5);
  border-radius: 10px;
}
.goods-distribution .txt1{
  padding: 10px 0 0 10px;
  font-size: 12px;
}
.goods-distribution .txt2{
  padding-left: 10px;
  font-size: 12px;
}
.goods-distribution .btn{
  display: flex;
  justify-content: flex-end;
  margin: 10px;
}
.goods-distribution .btn div{
  height: 25px;
  line-height: 25px;
  text-align: center;
  background: #1987F5;
  border-radius: 15px;
  font-size: 14px;
  color: #FFFFFF;
  padding: 0 10px;
}

/deep/ .van-dialog__confirm {
  background-color: #1987F5 !important; /* 自定义背景颜色 */
  color: #fff !important; /* 自定义字体颜色 */
}

.dialog-content{
  position: relative;
}
.qrCode{
  width: 120px;
  height: 120px;
}

.link-customer{
  position: fixed;
  bottom: 60px;
  left: 25px;
  z-index: 9;
}

@media screen and (max-width: 360px) {
  .share .ransmission{
    font-size: 12px;
  }
  .share div:nth-child(3){
    font-size: 12px !important;
  }

  .title-content div:nth-child(3){
    font-size: 14px !important;
  }

  .goods-distribution .btn div{
    font-size: 12px;
  }

}
/* iphone8 */
@media screen and (max-height: 670px) {
  .qrCode{
    width: 90px;
    height: 90px;
  }
}
</style>
